// RefillShop.jsx
import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import ContactModal from "../ContactModal/ContactModal";
import "./RefillShop.scss";

// replace these with your actual image imports
import laundryImg from "../../Assets/solutions/detergent-sheets-jar.png";
import kitchenImg from "../../Assets/solutions/bulk-order.png";
import cleaningImg from "../../Assets/solutions/refill-shop.png";

const categories = [
  {
    title: "Showcase Jars & Custom Labels",
    subtitle: "Dress your refill station with branded glass jars and simple, eco-friendly labels—so customers instantly recognize your laundry sheet offering.",
    img: laundryImg,
    link: "/refill/laundry-care",
  },
  {
    title: "Wholesale Loose Sheet Cases",
    subtitle: "Order one case (≈5,000 sheets) of unpackaged detergent strips. Ship them straight to your shop—no individual wrappings—ready for YOU to pre-bag or sell by weight.",
    img: kitchenImg,
    link: "/refill/kitchen-essentials",
  },
  {
    title: "Complete Refill Station Setup",
    subtitle: "We’ll guide you through every detail—branded jars, kraft pouch filling stations, portion-control cards, and display layouts—so your detergent sheet refill experience is seamless and professional.",
    img: cleaningImg,
    link: "/refill/cleaning-supplies",
  },
];

function RefillShop() {

  const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => setIsModalOpen(true);
    const handleCancel = () => setIsModalOpen(false);

  return (
    <Container className="refill-shop-wrapper py-5" id="refill">
      <h2 className="solution-option-title text-center">Bulk Unpacked Sheet Supply for Refill Shops:</h2>
      <p className="text-center text-muted mb-5 skewed">
      Ideal for Zero-Waste Retailers
      </p>

      <Row className="g-4 d-flex justify-center">
        <Col md={8}>
          <p>Order from just one box—approximately 5,000 loose sheets per case—so you can pre-package in your own eco-friendly bags or sell by weight in-store.</p>
        </Col>
      </Row>

      <Row className="g-4">
        {categories.map(({ title, subtitle, img, link }) => (
          <Col key={title} md={4}>
            <Card className="h-100 shadow-sm">
              <Card.Img variant="top" src={img} alt={title} />
              <Card.Body className="d-flex flex-column">
                <Card.Title>{title}</Card.Title>
                <Card.Text className="flex-grow-1 text-muted">
                  {subtitle}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="g-4 d-flex justify-center mt-5">
        <Col md={8}>
        <h3 className="mb-4">Key Benefits for Your Refill Shop</h3>
        <ul>
          <li><strong>Simple Starter Kit:</strong> One box (≈5,000 sheets) gets your refill program up and running—no huge minimums.</li>
          <li><strong>Perforated Convenience:</strong> Sheets come pre-split for easy dispensing and portion control.</li>
          <li><strong>DIY Packaging:</strong> Pre-bag sheets in your own kraft pouches or branded packaging at a fixed price.</li>
          <li><strong>Branded Kraft Pouches:</strong> We also supply plain kraft bags with your custom sticker—ready to fill and sell.</li>
          <li><strong>Jar &amp; Weigh Sales:</strong> Fill display jars with loose sheets—customers scoop, weigh, and pay by weight.</li>
          <li><strong>Fast U.S. Shipping:</strong> Shipped directly from our Columbus, Ohio warehouse with a 3–5 day lead time.</li>
          <li><strong>Showcase:</strong> Our ultra-low-PVA laundry sheets are available at <a
            href="https://thegoodgoods.co/product/klean-leaf-detergent-sheets-30ct-60-loads/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#134b4e', fontWeight: 'bold' }}
          >
            Good Goods
          </a> refill shops, helping them offer a greener refill option to their customers.</li>
        </ul>

        </Col>
      </Row>

      <div className="mt-4 text-center">
        <button
          className="secondary-btn"
          onClick={showModal}
        >
          Contact Us to Place Your First Order
        </button>

        <ContactModal
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
      />
      </div>
      
    </Container>
  );
}

export default RefillShop;
